import { useTranslation } from 'react-i18next';
import { Locale } from '@ivario-arc/shared/src/types/locales';
import { Logo } from '@components/atoms/Logo';
import {
  SUPPORTED_LOCALES,
  markLanguagePendingSync,
  setStoredLanguage,
} from '@utils/language';

const LOCALE_LABELS: Record<Locale, string> = {
  [Locale.DE]: '🇩🇪 Deutsch',
  [Locale.EN]: '🇬🇧 English',
  [Locale.NL]: '🇳🇱 Nederlands',
};

export function LandingHeader() {
  const { t, i18n } = useTranslation('view', { keyPrefix: 'landing' });

  const handleLanguageChange = (locale: Locale) => {
    setStoredLanguage(locale);
    markLanguagePendingSync(locale);
    void i18n.changeLanguage(locale);
    document.documentElement.lang = locale;
  };

  return (
    <header className="bg-white border-b border-grey2 h-[66px]">
      <div className="max-w-[1300px] mx-auto px-4 h-full flex items-center justify-between">
        <a href="https://ivario.com">
          <Logo />
        </a>
        <div className="flex items-center gap-2">
          <label
            htmlFor="headerLangSelect"
            className="text-sm text-gray-400 font-medium whitespace-nowrap hidden sm:inline"
          >
            {t('headerLangLabel')}
          </label>
          <select
            id="headerLangSelect"
            value={i18n.language}
            onChange={(e) => handleLanguageChange(e.target.value as Locale)}
            className="py-1.5 px-3 pr-8 border-[1.5px] border-grey2 rounded-lg font-semibold text-sm text-dark bg-grey3light cursor-pointer appearance-none bg-no-repeat bg-[right_11px_center] bg-[length:10px_6px] hover:border-ivarioBlue focus:border-ivarioBlue focus:outline-none transition-colors"
            style={{
              backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'%3E%3Cpath d='M1 1l4 4 4-4' stroke='%23718096' stroke-width='1.5' fill='none' stroke-linecap='round'/%3E%3C/svg%3E")`,
            }}
          >
            {SUPPORTED_LOCALES.map((locale) => (
              <option key={locale} value={locale}>
                {LOCALE_LABELS[locale]}
              </option>
            ))}
          </select>
        </div>
      </div>
    </header>
  );
}
